// A centred dialog on a wide screen (Add a reminder, Add an insight by hand), after the prototype's form dialogs: a
// title and Close, the form under it. Escape and the scrim close it; Tab stays inside (useSheetFocus). On a phone the
// same forms go in a bottom sheet (PSheet) instead.
import { useRef, type ReactNode } from 'react';
import { motion } from 'motion/react';
import { scrim, spring } from '../lib/motion';
import { IconX } from './icons';
import { useSheetFocus } from './Sheet';

export function Modal({ label, onClose, children, width = 560 }: { label: string; onClose: () => void; children: ReactNode; width?: number }) {
  const box = useRef<HTMLDivElement>(null);
  useSheetFocus(box, onClose);
  return (
    <>
      <motion.button type="button" className="scrim" aria-label="Close" tabIndex={-1} onClick={onClose} variants={scrim} initial="initial" animate="animate" exit="exit" />
      <div className="rmodal-host">
        <motion.div ref={box} className="rmodal" role="dialog" aria-modal="true" aria-label={label} style={{ width: `min(${width}px, 100%)` }}
          initial={{ opacity: 0, y: 12, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1, transition: spring.gentle }} exit={{ opacity: 0, y: 8, transition: { duration: 0.12 } }}>
          <div className="rmh"><b>{label}</b><button type="button" className="ib" aria-label="Close" onClick={onClose}><IconX /></button></div>
          {children}
        </motion.div>
      </div>
    </>
  );
}
